export function isPaginatedSortBy(sortBy) {
  return !(sortBy === 'BEST_SELLING' || sortBy === 'RECOMMENDATIONS');
}

export const sortIdToTrackingValue = {
  DEFAULT: 'Default',
  PRICE_ASC: 'Low To High',
  PRICE_DESC: 'High To Low',
  BEST_SELLING: 'Best Selling',
  RECOMMENDATIONS: 'Recommended',
};
